module.exports = __webpack_public_path__ + "img/rightFlip(1).ba4292d6.png";